import Image from 'next/image';
import Link from 'next/link';
import type { ReactElement } from 'react';

export function Logo(): ReactElement {
  return (
    <Link
      href="/"
      prefetch={process.env.NEXT_PUBLIC_PREFETCH === 'true'}
      className="order-2 mx-auto md:mx-0 md:order-0 relative h-[75px] w-[150px] scale-80 sm:scale-100 m-0"
    >
      <Image
        src="/images/header/bulk-nutrients-header-dark-icon.svg"
        fill
        alt="Bulk Nutrients Logo"
        className="object-contain hidden dark:block"
      />
      <Image
        src="/images/header/bulk-nutrients-header-icon.svg"
        fill
        alt="Bulk Nutrients Logo"
        className="object-contain dark:hidden"
      />
    </Link>
  );
}
